module.exports = __webpack_public_path__ + "img/esh.3b662831.svg";